<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Form :model="UsageSituationForm">
        <Row>
          <Col span="6">
            <FormItem label="签到时间" :label-width="80">
              <DatePicker type="daterange" v-model="UsageSituationForm.signTime" placeholder="选择日期"
                          @on-change="getUsageSituationData" clearable @on-clear="clearData"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :data="UsageSituationData" :columns="UsageSituationColumns" :loading="UsageSituationLoading"
             ref="UsageSituationRefs"></Table>
      <Button style="float: left;margin-top: 10px" type="primary"@click="exportData()">
        <Icon type="ios-download-outline"></Icon>
        导出
      </Button>
    </Card>
  </div>
</template>
<script>
export default {
  name: 'UsageSituation',
  data() {
    return {
      UsageSituationData: [],
      UsageSituationColumns: [
        {title: '单位名称', key: 'dept', align: 'center'},
        {title: '实际登录使用人数', key: 'actualUsersNumber', align: 'center'},
        {title: '登录使用率', key: 'loginUseRate', align: 'center'},
        {title: '同比增加率', key: 'increaseRate', align: 'center'},
      ],
      UsageSituationLoading: false,
      UsageSituationCurrentPage: 1,
      UsageSituationTotal: 0,
      UsageSituationPageSize: 10,
      pageSizeOpts: [10, 20, 30, 50],
      UsageSituationForm: {
        signTime: ['', '']
      }
    }
  },
  mounted() {
    this.UsageSituationForm.signTime = [this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
    this.getUsageSituationData()
  },
  methods: {
    clearData() {
      this.UsageSituationForm.signTime = [this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      this.getUsageSituationData()
    },
    exportData() {
      this.$refs.UsageSituationRefs.exportCsv({
        filename: this.$moment(new Date).format('yyyy-MM-DD') + '系统平台登录使用情况'
      });
    },
    getUsageSituationData() {
      this.UsageSituationLoading = true
      let requestData = {
        beginDate: new Date(this.UsageSituationForm.signTime[0]),
        endDate: new Date(this.UsageSituationForm.signTime[1]),
      }
      this.$http.post(`api/getSystemLoginUseSituation`, requestData).then(res => {
        if (res.status === 200) {
          this.UsageSituationData = res.data
          this.UsageSituationLoading = false
        }else {
          this.$Message.error(res.data.message)
          this.UsageSituationLoading = false
        }
      }).catch(err => {
        this.$Message.error(err)
        this.UsageSituationLoading = false
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
